export default {
  deleteNotification (state, value) {
    state.notificacao = state.notificacao.filter(elem => elem.url !== value)
  }
}



// WEBPACK FOOTER //
// ./src/store/notificacaoTabs/mutations.js